import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toastError, toastSuccess } from "../../utils/toastrResponse";
import DOMPurify from "dompurify";
import useAxios from "../../hooks/useAxios";

const CreateAccount = ({ show, hide, loadAccounts }) => {
  const [payload, setPayload] = useState({});
  const axiosInstance = useAxios();
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setPayload({
      ...payload,
      [name]: DOMPurify.sanitize(value),
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const url = `/payments/collectionAccounts`;
    axiosInstance({
      url,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: payload,
    })
      .then((res) => {
        if (res.status >= 200 && res.status <= 300) {
          toastSuccess("Collection account created");
          hide();
          loadAccounts();
        } else {
          toastError("Could not create account");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={hide}>
          <h5>Create Collection Account</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <form onSubmit={handleSubmit}>
            <label className='ml-2'>Name</label>
            <input
              className='form-control input-select mb-2'
              type='text'
              name='name'
              placeholder='Name'
              onChange={handleOnChange}
              required
            />
            <label className='ml-2'>Username</label>
            <input
              className='form-control input-select mb-2'
              type='text'
              name='username'
              placeholder='Username'
              onChange={handleOnChange}
            />
            <label className='ml-2'>Description</label>
            <textarea
              className='form-control input-select mt-2'
              name='description'
              placeholder='Description'
              onChange={handleOnChange}
              required
            />
            <div className='d-flex justify-content-center'>
              <Button className='custom-btn-color' type='submit'>
                Create Account
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateAccount;
